import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TicketFilesTitles, OrderAttachmentType } from 'src/app/@core/constants';
import { FileUtils } from 'src/app/@core/utils/file-utils';
import { TicketFile } from 'src/app/models/equipment-registration-ticket-file';
import { OrderAttachment } from 'src/app/models/order-attachment';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'pos-attachments',
  templateUrl: './pos-attachments.component.html',
  styleUrls: ['./pos-attachments.component.sass']
})
export class PosAttachmentsComponent implements OnInit, OnChanges {
  filesList: TicketFile[] = [
    { title: TicketFilesTitles.IDENTITY, isRequired: true, type: TicketFilesTitles.IDENTITY },
    { title: TicketFilesTitles.RTN, isRequired: false, type: TicketFilesTitles.RTN },
    { title: TicketFilesTitles.IP_800, isRequired: false, type: TicketFilesTitles.IP_800 },
    { title: TicketFilesTitles.THIRD_PARTY_AUTORIZATION, isRequired: false, type: TicketFilesTitles.THIRD_PARTY_AUTORIZATION },
    { title: TicketFilesTitles.ENROLLMENT_REJECT, isRequired: false, type: TicketFilesTitles.ENROLLMENT_REJECT },
    { title: TicketFilesTitles.DOMAIN_TRADITION_1, isRequired: false, type: TicketFilesTitles.DOMAIN_TRADITION_1 },
    { title: TicketFilesTitles.DOMAIN_TRADITION_2, isRequired: false, type: TicketFilesTitles.DOMAIN_TRADITION_2 },
  ];

  filesListDelivery: TicketFile[] = [
    { title: TicketFilesTitles.ROAD_SKETCH, isRequired: false, type: TicketFilesTitles.ROAD_SKETCH },
    { title: TicketFilesTitles.INVOICE, isRequired: false, type: TicketFilesTitles.INVOICE },
    { title: TicketFilesTitles.DELIVERY_FORMAT, isRequired: false, type: TicketFilesTitles.DELIVERY_FORMAT },
  ]

  @Input() automaticAttachments: Array<OrderAttachment> = [];
  @Input() useDeliveryFiles: boolean = false;
  @Input() useAccordion: boolean = true;
  @Output() changeFile = new EventEmitter<TicketFile[]>();

  constructor(private reportService: ReportService) { }

  ngOnInit(): void {

    if (this.useDeliveryFiles) {
      this.filesList = this.filesListDelivery;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.automaticAttachments && this.automaticAttachments.length) {
      this.automaticAttachments.forEach(aa => {
        let idx = -1;
        if (aa.type === OrderAttachmentType.FISCALID) {
          idx = 0;
        } else if (aa.type === OrderAttachmentType.RTNFISCALID) {
          idx = 1;
        } else if (aa.type === OrderAttachmentType.IP800) {
          idx = 2;
        }

        if (idx !== -1) {
          const file = FileUtils.dataURLtoFile(aa.data, aa.filename);
          this.filesList[idx].file = file;
          this.changeFile.emit(this.filesList);
        }
      });
    } else {
      this.filesList.forEach(f => {
        f.file = null;
        this.changeFile.emit(this.filesList);
      });
    }
  }

  onFileChange(event: any, index: number) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.filesList[index].file = file;

      this.changeFile.emit(this.filesList);
    }
  }

  async viewDocument(file: File) {
    this.reportService.printReport(file);
  }
}
